import { render, staticRenderFns } from "./productEditOnlineCourse.vue?vue&type=template&id=458a70ae&scoped=true"
import script from "./productEditOnlineCourse.vue?vue&type=script&lang=js"
export * from "./productEditOnlineCourse.vue?vue&type=script&lang=js"
import style0 from "./productEditOnlineCourse.vue?vue&type=style&index=0&id=458a70ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a70ae",
  null
  
)

export default component.exports